<template>
 <nav  class="navbar navbar-expand-lg" role="navigation" aria-label="Menu principal">
    <div v-if="isReady" class="container-fluid d-flex justify-content-between">
      <!-- Logo -->
      <div class="text-center d-flex">
        <nuxt-link class="navbar-brand" to="/" aria-label="Retour à l’accueil Longoka" :aria-current="$route.path === '/' ? 'page' : null">
          <LogoFooter />
          <span class="text-center text-white">Longoka</span>
        </nuxt-link>
      </div>

      <!-- Toggler pour mobile -->
      <button
        class="navbar-toggler"
        type="button"
        @click="isMenuOpen = !isMenuOpen"
        :aria-expanded="isMenuOpen"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Liens de navigation -->
      <div
        class="collapse navbar-collapse justify-content-end"
        :class="{ show: isMenuOpen }"
      >
        <ul class="navbar-nav breadcrumb" role="menubar">
                  <!-- Panier (connecté uniquement, sauf admin) -->
                  <li
  v-if="isLoggedIn && notifications.length > 0"
  class="nav-item dropdown me-3 position-relative"

  role="none"
  ref="notifContainer"
>

<button
  type="button"
  class="btn position-relative nav-link cursor-pointer"  
  ref="notifButton"
  @click.stop="toggleNotifDropdown"
   @keydown.enter.prevent="toggleNotifDropdown"
 @keydown.space.prevent="toggleNotifDropdown"
  aria-label="Notifications"
  aria-haspopup="menu"
  :aria-expanded="showDropdown ? 'true' : 'false'"
   aria-controls="notifDropdown"
>
  <i class="fas fa-bell fa-lg"></i>
  <span
    v-if="unreadCount > 0"
    class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
    style="pointer-events:none"      
     aria-live="polite"
 aria-atomic="true"
  >
    {{ unreadCount }}
  </span>
   <span class="d-none d-lg-inline ms-1">Notifications</span>
</button>


    <div
      id="notifDropdown"
      ref="notifDropdown"
      :class="['dropdown-menu dropdown-menu-end shadow bg-white rounded p-3', { show: showDropdown }]"
      style="width: 350px; max-height: 450px; overflow-y: auto;"
      role="menu"
      aria-label="Liste des notifications"
    >
      <h4 class="dropdown-header my-2 card "><span class="card-header lesson-title text-center">📢 Notifications</span></h4>
   <!-- En-tête avec boutons action -->
   <div class="d-flex justify-content-between align-items-center mb-2 px-1 mt-2">
    <!-- Tout marquer comme lu -->
    <button
      type="button"
      class="btn btn-primary btn-sm d-flex align-items-center me-2"
      @click.stop="markAllRead"
      :disabled="!unreadCount"
      aria-label="Tout marquer comme lu"
    >
      <i class="fas fa-check"></i>
      <span class="d-none d-sm-inline ms-1">Tout lu</span>
    </button>

    <!-- Tout retirer -->
    <button
      type="button"
      class="btn btn-danger btn-sm d-flex align-items-center me-2"
      @click.stop="removeAllNotifications"
      :disabled="notifications.length === 0"
      aria-label="Tout retirer"
    >
      <i class="fas fa-trash-alt"></i>
      <span class="d-none d-sm-inline ms-1">Tout retirer</span>
    </button>

    <!-- Croix de fermeture du dropdown -->
    <button
      type="button"
      class="btn-close btn-danger"
      @click.stop="toggleNotifDropdown"
      aria-label="Fermer"
    ></button>
  </div>

<hr class="my-3">
<!-- État “Aucune notification” -->
<div
  v-if="notifications.length === 0"
  class="d-flex flex-column justify-content-center align-items-center py-4 text-muted small card"
>
  <i class="fas fa-inbox fa-2x mb-2"></i>
  Aucune notification
</div>

      <ul
  class="list-group list-group-flush px-2 "
  role="menu"
  aria-label="Notifications"
>
  <li
    v-for="notif in displayedNotifications"
    :key="notif.notification_id"
    class="list-group-item list-group-item-action d-flex align-items-start p-2 mb-2 bg-white rounded shadow-sm"
    role="menuitem"
    tabindex="0"
    @click="markAsRead(notif.notification_id)"
    @keydown.enter.prevent="markAsRead(notif.notification_id)"
  >
    <!-- 1) Petite icône à gauche pour repère visuel -->
    <div class="me-3 text-primary">
      <i class="fas fa-info-circle fa-lg"></i>
    </div>

    <!-- 2) Texte cliquable, title + date -->
    <div class="flex-grow-1 cursor-pointer">
     
<p
   class="mb-1 cursor-pointer"
   :class="{
     ' text-dark': notif.is_read,
     ' text-primary': !notif.is_read
   }"
   role="button"
   tabindex="0"
   @click.stop="markAsRead(notif.notification_id)"
   @keydown.enter.prevent="markAsRead(notif.notification_id)"
   aria-label="Marquer la notification comme lue"
 >
   {{ notif.message }}
 </p>

      <time class="text-muted small d-block">
        {{ formatDate(notif.created_at) }}
      </time>
    </div>

    <!-- 3) Croix “btn-close” toujours visible -->
    <button
      type="button"
      class="btn-close ms-2 flex-shrink-0"
      @click.stop="removeNotification(notif.notification_id)"
      aria-label="Supprimer la notification"
    ></button>
  </li>
</ul>

      <div v-if="totalPages > 1" class="px-3 py-2 border-top card mt-2">
        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @pageChange="handlePageChange"
        />
      </div>

      <div class="text-center py-2 border-top">
        <NuxtLink to="/student/notifications" class="small text-primary">
          Voir toutes les notifications
        </NuxtLink>
      </div>
    </div>
  </li>
       
<li
  v-if="!isAdmin && cartCount"
  class="nav-item dropdown me-3"
  role="none"
>
<nuxt-link
 to="/cart"
 class="nav-link d-flex align-items-center"
 @click="closeMenu"
 role="menuitem"
 aria-label="Voir le panier"
 :aria-current="$route.path === '/cart' ? 'page' : null"
>
 <span class="icon-container position-relative">
   <i class="fas fa-shopping-cart fa-lg"></i>
   <span
     v-if="cartCount"
     class="badge bg-danger badge-cart position-absolute"
   >
     {{ cartCount }}
   </span>
 </span>
 <span class="d-none d-lg-inline ms-1">Panier</span>
</nuxt-link>

</li>

<li v-else class="nav-item dropdown me-3" role="none">
  <nuxt-link
    to="/cart"
    class="nav-link position-relative"
    @click="closeMenu"
    role="menuitem"
    aria-label="Voir le panier"
  >
    <i class="fas fa-shopping-cart fa-lg"></i>
  </nuxt-link>
</li>


          <!-- Liens fixes -->
          <li class="nav-item" role="none">
            <nuxt-link class="nav-link" to="/" @click="closeMenu" role="menuitem" :aria-current="$route.path === '/' ? 'page' : null">
              <i class="fas fa-home"></i> Accueil
            </nuxt-link>
          </li>
          <li class="nav-item" role="none">
            <nuxt-link class="nav-link" to="/courses" @click="closeMenu" role="menuitem" :aria-current="$route.path === '/courses' ? 'page' : null">
              <i class="fas fa-book-open"></i> Cours
            </nuxt-link>
          </li>
          <li class="nav-item" role="none">
            <nuxt-link class="nav-link" to="/articles" @click="closeMenu" role="menuitem" :aria-current="$route.path === '/articles' ? 'page' : null">
              <i class="fas fa-newspaper"></i> Articles
            </nuxt-link>
          </li>
          <li class="nav-item" role="none">
         
            <nuxt-link class="nav-link d-flex align-items-center" 
            to="/shop" @click="closeMenu" role="menuitem" :aria-current="$route.path === '/shop' ? 'page' : null"
            >
 <i class="fa-solid fa-bag-shopping"></i>
 <span class="ms-2">Boutique</span>
</nuxt-link>

          </li>
          <!--   <li
            v-for="link in roleLinks"
            :key="link.role"
            class="nav-item"
            @click="closeMenu" role="none"
            
          >
            <nuxt-link class="nav-link" :to="link.path" role="menuitem" :aria-current="$route.path === link.path ? 'page' : null">
              <i :class="link.icon"></i> {{ link.label }}
            </nuxt-link>
          </li>-->
<!-- Nom d'utilisateur avec lien vers le profil -->

          <li v-if="isLoggedIn && user.username" class="nav-item" role="none">
            <nuxt-link
  class="nav-link"
  :to="`/profile/${usernameSlug}`"
  @click="closeMenu"
  role="menuitem"
>
  <i class="fas fa-user-check" aria-hidden="true" ></i>
  {{ username }}
</nuxt-link>

          </li>
<li
  v-if="isLoggedIn && isAdmin"
  class="nav-item dropdown me-3"
  role="none"
>
<nuxt-link
 to="/admin/chat"
 class="nav-link d-flex align-items-center"
 @click="closeMenu"
 role="menuitem"
 aria-label="Chat"
 :aria-current="$route.path === '/admin/chat' ? 'page' : null"
>Chat</nuxt-link></li>

          <!-- Bouton de déconnexion -->
          <li v-if="isLoggedIn" class="nav-item" role="none">
            <nuxt-link to="/"
              class="btn btn-link nav-link"
              @click="
                logout();
                closeMenu();
              "
              role="menuitem" aria-label="Se déconnecter de votre compte"
            >
              <i class="fas fa-sign-out-alt"></i> Déconnexion
            </nuxt-link>
          </li>

          <!-- Lien de connexion pour les utilisateurs non connectés -->
          <li v-if="!isLoggedIn" class="nav-item" role="none">
            <nuxt-link class="nav-link" to="/login" @click="closeMenu" role="menuitem" :aria-current="$route.path === '/login' ? 'page' : null">
              <i class="fas fa-sign-in-alt"></i> Connexion
            </nuxt-link>
          </li>
 

        </ul>

      </div>


    </div>
     <div v-else class="text-center py-3">
    <i class="fa fa-spinner fa-spin"></i> Chargement...
  </div>
  </nav>
   
</template>

<script setup>
import { ref, computed, onMounted,  onBeforeUnmount, watchEffect } from "vue";
import { useAuthStore } from "~/stores/authStore";
import { useCartStore } from "~/stores/cartStore";
import { useUserStore } from "~/stores/userStore";
import Pagination from "~/components/Pagination.vue";
  const authStore = useAuthStore();
  const userStore = useUserStore();

const isReady = computed(() => import.meta.server ? true : authStore.isRestored)

const notifications = computed(() => userStore.notifications);
const cartStore = useCartStore();
const isMenuOpen = ref(false);
const notifContainer = ref(null);
const notifButton = ref(null);
const notifDropdown = ref(null);

// États utilisateur
const isLoggedIn = computed(() => authStore.isLoggedIn);
//const restoreAuth = computed(() => authStore.profile.restoreAuth);
const username = computed(() => {
  if (!authStore.isLoggedIn) return "";
  return authStore.profile?.username || "Mon Profil";
});

const user = computed(() => authStore.profile); // direct
let _docClickHandler = null

const isAdmin = computed(() => authStore.profile.roles?.includes("admin"));
const cartCount = computed(() => cartStore.items.length || 0);
const usernameSlug = computed(() => {
  const raw = authStore.profile?.username || "";
  return raw
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9\-]/g, "");
});

// Liens dynamiques par rôle
const roleLinks = computed(() => {
  const roles = authStore.profile?.roles || [];
  const links = [];

  if (roles.includes("admin")) {
    links.push({
      role: "admin",
      path: "/admin",
      label: "Admin",
      icon: "fas fa-tools",
    });
  }
  if (roles.includes("instructor")) {
    links.push({
      role: "instructor",
      path: "/instructor",
      label: "Instructeur",
      icon: "fas fa-chalkboard-teacher",
    });
  }
  if (roles.includes("blogger")) {
    links.push({
      role: "blogger",
      path: "/blogger",
      label: "Blogger",
      icon: "fas fa-pen-nib",
    });
  }
  if (roles.includes("student")) {
    links.push({
      role: "student",
      path: "/student",
      label: "Étudiant",
      icon: "fas fa-user-graduate",
    });
  }
  if (roles.includes("user")) {
    links.push({
      role: "user",
      path: "/user",
      label: "Utilisateur",
      icon: "fas fa-user",
    });
  }
  return links;
});

// Déconnexion
const logout = () => {
  authStore.logout();
  
};
const closeMenu = () => {
  if (import.meta.client && window.innerWidth < 992) {
    isMenuOpen.value = false;
  }
};

const unreadNotifications = ref(0);

const showDropdown = ref(false);
const unreadCount = computed(() =>
  userStore.notifications.filter(n => n && (n.is_read === 0 || n.is_read === false)).length
);

/*
function toggleNotifDropdown() {
  showDropdown.value = !showDropdown.value;
}*/

function closeNotifDropdown() {
  showDropdown.value = false;
}

async function markAsRead(notificationId) {
 await userStore.markNotificationAsRead(notificationId);
}


/*async function markAsRead(notificationId) {
  await useFetch('/api/notifications/update-read', {
    method: 'PUT',
    body: { notification_id: notificationId }
  });

  // Mise à jour locale
  const notif = notifications.value.find(n => n.notification_id === notificationId);
  if (notif) notif.is_read = 1;
}*/

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' });
}


function handleOutsideClick(event) {
  const dropdown = document.querySelector(".nav-item.dropdown");
 
}

function toggleNotifDropdown() {
  showDropdown.value = !showDropdown.value;
}
const itemsPerPage = 3;
const currentPage = ref(1);

// Calcul du nombre total de pages
const totalPages = computed(() =>
  Math.ceil(notifications.value.length / itemsPerPage)
);

// Notifications à afficher sur la page en cours
const displayedNotifications = computed(() =>
  notifications.value.slice(
    (currentPage.value - 1) * itemsPerPage,
    currentPage.value * itemsPerPage
  )
);
async function removeNotification(notificationId) {
 await userStore.removeNotification(notificationId);
}
/**
 * Soft-delete toutes les notifications de l'utilisateur
 */
 async function removeAllNotifications() {
  // Appelle un nouvel endpoint qui fait `UPDATE notifications SET is_removed=1 WHERE user_id = ?`
 await userStore.removeAllNotifications() ;
  // Mise à jour locale : on vide complètement la liste

}

// juste après removeNotification(...)
async function markAllRead() {
 await userStore.markAllNotificationsAsRead();


  // (facultatif) Recalcul automatique via computed unreadCount
}

function handlePageChange(page) {
  currentPage.value = page;
}
 // 1) Charger le panier (guest et user)
onMounted(async () => {
 // 0) Ne rien faire côté serveur
 //if (!import.meta.client) return;

 await cartStore.setCart();


 // 2) Si user connecté → charger ses notifications
 /*watchEffect(async () => {
   if (authStore.isRestored && authStore.isLoggedIn) {
     try {
       const { data, error } = await useFetch("/api/notifications", { method: "GET" });
       if (!error.value && data.value?.success) {
         notifications.value = data.value.notifications;
       }
     } catch (err) {
       console.error("Exception fetch notifications :", err);
     }
   }
 });*/
 if (authStore.isRestored && authStore.isLoggedIn) {
        try {
     userStore.fetchNotifications();
  } catch (err) {
    console.error("Impossible de charger les notifications :", err);
  }

}
 // 3) Gestion du clic extérieur & menu mobile
 _docClickHandler = (e) => {
   const target = e.target;
   const clickedInsideNotif =
     notifContainer.value?.contains(target) ||
     notifButton.value?.contains(target) ||
     notifDropdown.value?.contains(target);

   if (!clickedInsideNotif) {
     showDropdown.value = false;
   }

   const nav = document.querySelector(".navbar");
   if (isMenuOpen.value && nav && !nav.contains(target)) {
     isMenuOpen.value = false;
   }
}
  document.addEventListener("click", _docClickHandler)
});

onBeforeUnmount(() => {
  if (_docClickHandler) {
    document.removeEventListener("click", _docClickHandler)
    _docClickHandler = null
  }
})
/*watch(
  () => authStore.isRestored,
  (restored) => {
    if (restored && authStore.isLoggedIn) {
      // par exemple, fetch notifications ou autre
  
    }
  },
  { immediate: true }
);
*/


</script>

<style scoped>

.navbar {
  background-color: #169a7a;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.nav-link {
 display: flex;
 align-items: center;
 position: relative;
 /* Garde même padding partout */
 padding: 0.5rem 1.1rem;
 min-height: 48px;
 color: #fff;

}

.badge-cart,
.badge-notif {
 font-size: 0.82em;
 min-width: 1.6em;
 height: 1.5em;
 display: flex;
 align-items: center;
 justify-content: center;
 top: 2px;
 left: 1.2em;
 /* Mobile: ajuste pour rester au coin */
 /* Passe en haut à droite de l'icône */
 /* Surcharger si besoin par media queries */
}
@media (max-width: 700px) {
 .nav-link {
   padding: 0.6rem 1rem;
   min-height: 44px;
 }
 .badge-cart,
 .badge-notif {
   left: 1.5em;
   top: 1px;
 }
}


.nav-link:hover {
  color: #292929;
}
i {
  color: #fff;
}
i:hover {
  color: #292929;
}
.navbar-toggler-icon {
  background-color: #fff;
  height: 2px;
  width: 24px;
  position: relative;
}

.navbar-toggler-icon::before,
.navbar-toggler-icon::after {
  content: "";
  position: absolute;
  background-color: #fff;
  height: 2px;
  width: 24px;
  top: -8px;
}

.navbar-toggler-icon::after {
  top: 8px;
}

.btn-link {
  color: #fff;
  text-decoration: none;
}

.btn-link:hover {
  color: #292929;
}

.nav-item .fas {
  margin-right: 5px;
}
.navbar-collapse {
  transition: max-height 0.3s ease;
}
.nav-link:focus-visible {
  outline: 2px dashed #fff;
  outline-offset: 4px;
}
.nav-link[aria-current="page"] {
  font-weight: bold;
  color: #292929; /* ou une autre couleur bien contrastée */
}


/* Responsive styles */
@media (max-width: 992px) {
  .navbar-nav {
    text-align: center;
    margin-top: 1rem;
  }

  .nav-item {
    margin-bottom: 0.5rem;
  }
}
.icon-container {
 display: inline-block;
 position: relative;
 min-width: 1.7em;
 min-height: 1.6em;
}

.badge-cart,
.badge-notif {
 font-size: 0.82em;
 min-width: 1.35em;
 height: 1.3em;
 display: flex;
 align-items: center;
 justify-content: center;
 /* Placement précis au coin de l'icône */
 top: -5px;
 right: -8px;
 z-index: 2;
}
button.nav-link { cursor: pointer; }
.nav-link .badge { pointer-events: none; }

.badge.position-absolute {
 position: absolute !important;
}

@media (max-width: 991px) {
 .icon-container {
   min-width: 1.5em;
   min-height: 1.3em;
 }
 .badge-cart,
 .badge-notif {
   top: -2px;
   right: -4px;
   font-size: 0.79em;
 }
}

</style>